import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { requestEnrollment } from "./clientCourseService";
import Navbar from "../nav_bar/Navbar";

const CourseCheckoutPage = () => {
  const { id, batchId } = useParams();
  const navigate = useNavigate();
  const { user, authLoading } = useAuth();

  const [status, setStatus] = useState("confirm"); // confirm | loading | success | error | already
  const [errorMsg, setErrorMsg] = useState("");
  const submittedRef = useRef(false);

  useEffect(() => {
    if (authLoading) return;
    if (!user) { navigate(`/login?redirect=/courses/${id}/enroll/${batchId}`, { replace: true }); return; }
    if (!batchId) { navigate(`/courses/${id}`, { replace: true }); }
  }, [authLoading, user, batchId, id, navigate]);

  const handleConfirm = async () => {
    if (submittedRef.current) return;
    submittedRef.current = true;
    setStatus("loading");

    try {
      await requestEnrollment(Number(batchId));
      setStatus("success");
    } catch (err) {
      submittedRef.current = false;
      const code = err?.response?.data?.code || "";
      const msg  = err?.response?.data?.message || "";
      if (err?.response?.status === 409 || code === "ALREADY_ENROLLED" || msg.toLowerCase().includes("already enrolled")) {
        setStatus("already");
      } else {
        setErrorMsg(msg || "Something went wrong. Please try again.");
        setStatus("error");
      }
    }
  };

  return (
    <>
      <Navbar />
      <div style={{ maxWidth: 480, margin: "80px auto", padding: "0 1rem", textAlign: "center" }}>

        {status === "confirm" && (
          <div style={{ background: "#fff", borderRadius: 12, padding: "2rem", boxShadow: "0 2px 12px rgba(0,0,0,0.08)" }}>
            <div style={{ fontSize: "2.5rem", marginBottom: "0.75rem" }}>📋</div>
            <h2 style={{ margin: "0 0 0.5rem", fontSize: "1.2rem" }}>Confirm Enrollment Request</h2>
            <p style={{ color: "#6b7280", fontSize: "0.9rem", margin: "0 0 1.5rem" }}>
              Once confirmed, our team will contact you on your registered phone/WhatsApp to complete the payment.
            </p>
            <div style={{ display: "flex", gap: "0.75rem", justifyContent: "center" }}>
              <button
                onClick={() => navigate(`/courses/${id}`)}
                style={{ padding: "0.6rem 1.25rem", borderRadius: 8, border: "1px solid #d1d5db", background: "#fff", cursor: "pointer", fontSize: "0.9rem" }}
              >
                Cancel
              </button>
              <button
                onClick={handleConfirm}
                style={{ padding: "0.6rem 1.5rem", borderRadius: 8, border: "none", background: "#007BFF", color: "#fff", cursor: "pointer", fontSize: "0.9rem", fontWeight: 600 }}
              >
                Confirm Enrollment
              </button>
            </div>
          </div>
        )}

        {status === "loading" && (
          <div>
            <div style={{ fontSize: "2rem", marginBottom: "0.75rem" }}>⏳</div>
            <p style={{ color: "#6b7280" }}>Submitting your enrollment request…</p>
          </div>
        )}

        {status === "success" && (
          <div style={{ background: "#f0fdf4", borderRadius: 12, padding: "2rem", boxShadow: "0 2px 12px rgba(0,0,0,0.08)" }}>
            <div style={{ fontSize: "2.5rem", marginBottom: "0.75rem" }}>🎉</div>
            <h2 style={{ margin: "0 0 0.5rem", color: "#15803d" }}>Enrollment Requested!</h2>
            <p style={{ color: "#4b5563", fontSize: "0.9rem", margin: "0 0 1.5rem" }}>
              Our team will contact you on your registered WhatsApp/phone to confirm payment and activate your enrollment.
            </p>
            <button
              onClick={() => navigate("/my-courses", { replace: true })}
              style={{ padding: "0.6rem 1.5rem", borderRadius: 8, border: "none", background: "#16a34a", color: "#fff", cursor: "pointer", fontSize: "0.9rem", fontWeight: 600 }}
            >
              View My Courses
            </button>
          </div>
        )}

        {status === "already" && (
          <div style={{ background: "#eff6ff", borderRadius: 12, padding: "2rem", boxShadow: "0 2px 12px rgba(0,0,0,0.08)" }}>
            <div style={{ fontSize: "2.5rem", marginBottom: "0.75rem" }}>✅</div>
            <h2 style={{ margin: "0 0 0.5rem", color: "#1d4ed8" }}>Already Enrolled</h2>
            <p style={{ color: "#4b5563", fontSize: "0.9rem", margin: "0 0 1.5rem" }}>
              You already have an enrollment request or active enrollment for this batch.
            </p>
            <button
              onClick={() => navigate("/my-courses", { replace: true })}
              style={{ padding: "0.6rem 1.5rem", borderRadius: 8, border: "none", background: "#2563eb", color: "#fff", cursor: "pointer", fontSize: "0.9rem", fontWeight: 600 }}
            >
              View My Courses
            </button>
          </div>
        )}

        {status === "error" && (
          <div style={{ background: "#fef2f2", borderRadius: 12, padding: "2rem", boxShadow: "0 2px 12px rgba(0,0,0,0.08)" }}>
            <div style={{ fontSize: "2.5rem", marginBottom: "0.75rem" }}>❌</div>
            <h2 style={{ margin: "0 0 0.5rem", color: "#b91c1c" }}>Request Failed</h2>
            <p style={{ color: "#4b5563", fontSize: "0.9rem", margin: "0 0 1.5rem" }}>{errorMsg}</p>
            <div style={{ display: "flex", gap: "0.75rem", justifyContent: "center" }}>
              <button
                onClick={() => navigate(`/courses/${id}`)}
                style={{ padding: "0.6rem 1.25rem", borderRadius: 8, border: "1px solid #d1d5db", background: "#fff", cursor: "pointer", fontSize: "0.9rem" }}
              >
                Back to Course
              </button>
              <button
                onClick={() => { submittedRef.current = false; setStatus("confirm"); }}
                style={{ padding: "0.6rem 1.5rem", borderRadius: 8, border: "none", background: "#dc2626", color: "#fff", cursor: "pointer", fontSize: "0.9rem", fontWeight: 600 }}
              >
                Try Again
              </button>
            </div>
          </div>
        )}

      </div>
    </>
  );
};

export default CourseCheckoutPage;
